import SocialAuth from '@/components/auth/social-auth';
import ErrorCard from '@/components/card/error-card';
import { PasswordInputCustom } from '@/components/input/password-input';
import { routes } from '@/lib/routes';
import { CompanyLogo } from '@/public/icon/company-logo';
import { FormLoginValue } from '@/types/auth';
import { Button, Card, Center, Flex, Text, TextInput } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';
import { BuiltInProviderType } from 'next-auth/providers/index';
import Link from 'next/link';
import { Dispatch, SetStateAction } from 'react';
import ConsentDisclaimer from './consent-disclaimer';

type Props = {
  isLoading: boolean;
  error: string;
  setError: Dispatch<SetStateAction<string>>;
  form: UseFormReturnType<FormLoginValue>;
  onLogin: (value: FormLoginValue, callback: (error: string) => void) => void;
  onSocialAuth: (
    provider: BuiltInProviderType,
    agent?: string,
    ref?: string
  ) => void;
  isLoadingProvider: BuiltInProviderType | null;
};

const LoginContent = ({
  isLoading,
  error,
  setError,
  form,
  onLogin,
  onSocialAuth,
  isLoadingProvider,
}: Props) => {
  return (
    <Flex className="flex-col items-center justify-center">
      <Center mb={'20px'}>
        <Flex className="flex-col items-center justify-center">
          <CompanyLogo />
          <Text className="auth-text-title mt-2 whitespace-pre-line text-center text-[14px]">
            {'Your AI companion for complex \ntransaction risk management'}
          </Text>
        </Flex>
      </Center>
      <form
        className="flex w-full justify-center"
        onSubmit={form.onSubmit((value) =>
          onLogin(value, (e) => {
            setError(e);
          })
        )}
        style={{ position: 'relative' }}
      >
        <Card padding={40} className="auth-small-card font-inter">
          <Text className="auth-text-header">Welcome back</Text>
          <SocialAuth
            onSocialAuth={onSocialAuth}
            isLoadingProvider={isLoadingProvider}
          />
          <ErrorCard error={error} />
          <TextInput
            {...form.getInputProps('email')}
            placeholder="hi@acmecorporation.com"
            label="Email address"
            mb={'md'}
          />
          <PasswordInputCustom
            mb={'16px'}
            placeholder={'********'}
            {...form.getInputProps('password')}
          />
          <Link href={routes.auth.forgetPassword} className="mb-[16px]">
            <Text className="font-twk text-[14px] font-[650] text-vibrantgreen">
              Forgot password?
            </Text>
          </Link>
          <Button
            variant="primary"
            size="md"
            loading={isLoading}
            type="submit"
            className="w- mb-[32px]"
          >
            Login
          </Button>
          <ConsentDisclaimer bg="#F3F4F6" />
        </Card>
      </form>
    </Flex>
  );
};

export default LoginContent;
